import "whatwg-fetch";

import Action from "../../../action/Action.ts";
import ResponseData from "../../../action/ResponseData.ts";
import MailTemplateUpdateForm from "./MailTemplateUpdateForm.ts";
import MailTemplateTestForm from "./MailTemplateTestForm.ts";
const MailTemplateAction = {
    getList(token: string, accommodation_id: string, callback: (data: ResponseData) => void, errorHandler: (error: unknown) => void) {
        const path = "/admin/accommodations/" + accommodation_id + "/mail_templates";
        const header = new Headers();
        const body = null;
        Action.fetchAuthorizedJson(path, token, "GET", header, body, callback, errorHandler);
    },
    getDetail(token: string, accommodation_id: string, id: string, callback: (data: ResponseData) => void, errorHandler: (error: unknown) => void) {
        const path = "/admin/accommodations/" + accommodation_id + "/mail_templates/" + id;
        const header = new Headers();
        const body = null;
        Action.fetchAuthorizedJson(path, token, "GET", header, body, callback, errorHandler);
    },
    create(
        token: string,
        accommodation_id: string,
        form: MailTemplateUpdateForm,
        callback: (data: ResponseData) => void,
        errorHandler: (error: unknown) => void,
    ) {
        const path = "/admin/accommodations/" + accommodation_id + "/mail_templates";
        const header = new Headers();
        header.set("Content-Type", "application/json");

        const formData = form.createFormData(true);

        Action.fetchAuthorizedJson(path, token, "POST", header, formData, callback, errorHandler);
    },
    update(
        token: string,
        accommodation_id: string,
        id: string,
        form: MailTemplateUpdateForm,
        callback: (data: ResponseData) => void,
        errorHandler: (error: unknown) => void,
    ) {
        const path = "/admin/accommodations/" + accommodation_id + "/mail_templates/" + id;
        const header = new Headers();
        header.set("Content-Type", "application/json");

        // MailTemplateUpdateFormからJSON文字列を生成
        const formData = form.createFormData();

        Action.fetchAuthorizedJson(path, token, "PATCH", header, formData, callback, errorHandler);
    },

    sendTestMail(
        token: string,
        accommodation_id: string,
        id: string,
        form: MailTemplateTestForm,
        callback: (data: ResponseData) => void,
        errorHandler: (error: unknown) => void,
    ) {
        const path = "/admin/accommodations/" + accommodation_id + "/mail_templates/" + id + "/test";
        const header = new Headers();
        header.set("Content-Type", "application/json");

        const formData = form.createFormData();

        Action.fetchAuthorizedJson(path, token, "POST", header, formData, callback, errorHandler);
    },
};

export default MailTemplateAction;
